import React from 'react';

const SvgStandard: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-4 -4 24 24"
    {...props}
  >
    <path
      fill="#5A636B"
      d="M2.692 12.4v1a.58.58 0 0 1-.172.427.58.58 0 0 1-.428.173H1.6a.58.58 0 0 1-.427-.173A.58.58 0 0 1 1 13.4V7.262L2.634 2.6a.822.822 0 0 1 .328-.438.922.922 0 0 1 .53-.162h8.646c.188 0 .358.055.51.165a.85.85 0 0 1 .318.435L14.6 7.262V13.4a.58.58 0 0 1-.173.427A.58.58 0 0 1 14 14h-.492a.58.58 0 0 1-.428-.173.58.58 0 0 1-.172-.427v-1H2.692Zm-.006-6.338h10.228L11.904 3.2H3.696L2.686 6.062Zm1.485 4.215c.291 0 .538-.102.74-.306.203-.204.304-.45.304-.742 0-.291-.101-.538-.305-.74a1.014 1.014 0 0 0-.743-.304c-.29 0-.537.101-.74.305a1.014 1.014 0 0 0-.304.743c0 .29.102.537.306.74.204.203.45.304.742.304Zm7.262 0c.29 0 .537-.102.74-.306.203-.204.304-.45.304-.742 0-.291-.102-.538-.306-.74a1.013 1.013 0 0 0-.742-.304c-.291 0-.538.101-.74.305a1.014 1.014 0 0 0-.304.743c0 .29.101.537.305.74.204.203.452.304.743.304Z" // eslint-disable-line max-len
    />
  </svg>
);

export default SvgStandard;
